module.exports = __webpack_public_path__ + "static/media/xLargeFont.5a0c2604.webp";